module.exports = __webpack_public_path__ + "img/antwan-robinson-video-placeholder.5f68fa61.jpg";